import React, { useState } from "react"
import styled from "styled-components"
import { StaticQuery, graphql, Link } from "gatsby"
import theme from "../utils/theme"
import { toRem } from "../utils"
import slugify from "slugify"
import { getCurrentLang } from "../i18n"
import Fuse from "fuse.js"

const SearchBarInput = styled.input`
  width: 100%;
  border: 1px solid #c5c5c5;
  font-size: ${toRem(21)};
  color: ${theme.colors.gray};
  border-radius: 5px;
  height: ${toRem(60)};
  padding: 0 ${toRem(20)};
`

const ResultsBox = styled.div`
  box-sizing: border-box;
  height: auto;
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  background-color: #ffffff;
  color: ${theme.colors.gray};
  padding: ${toRem(20)};
  position: absolute;
  z-index: 100;
  width: inherit;
`

const ResultItem = styled(Link)`
  font-size: 18px;
  line-height: 22px;
  color: #ababab;
  font-weight: 400;
  padding: ${toRem(10)} 0;
  display: inline-block;
  text-decoration: none;
`
const fuzzySearchOptions = {
  keys: ["title", "tags"],
  shouldSort: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 2,
  includeScore: true,
  tokenize: true
}

const SearchBar = ({ data, placeholder }) => {
  const { edges: subsections } = data.allMarkdownRemark
  const [showResults, setShowResults] = useState(false)
  const [results, setResults] = useState([])

  const subWithFormat = subsections
    .filter(item => item.node.frontmatter.language === getCurrentLang())
    .flatMap(({ node: sub }) =>
      sub.frontmatter.items.flatMap(item => {
        return {
          slug: sub.fields.slug,
          title: item.title,
          tags: item.tags,
          matchs: 0
        }
      })
    )
  let timeout = null
  let blurTimeout = null

  const fuse = new Fuse(subWithFormat, fuzzySearchOptions)

  // debounce
  const onChange = event => {
    clearTimeout(timeout)
    const value = event.target.value
    timeout = setTimeout(() => changed(value), 500)
  }

  const changed = value => {
    const results = fuse.search(value)
    setResults(results)
    setShowResults(true)
  }

  return (
    <>
      <SearchBarInput
        placeholder={placeholder}
        onKeyUp={event => onChange(event, subsections)}
        onBlur={() => setTimeout(() => setShowResults(false), 200)}
        onFocus={() => setShowResults(true)}
      ></SearchBarInput>
      {showResults && results.length > 0 && (
        <ResultsBox>
          {results.map((item, index) => {
            return (
              <div key={index}>
                <ResultItem
                  onClick={() => {
                    clearTimeout(blurTimeout)
                    setShowResults(false)
                  }}
                  to={`${item.item.slug}/#${slugify(item.item.title, {
                    lower: true
                  })}`}
                >
                  {item.item.title}
                </ResultItem>
              </div>
            )
          })}
        </ResultsBox>
      )}
    </>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query SearchBar {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___title] }
          filter: { frontmatter: { templateKey: { eq: "help-center" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                templateKey
                title
                language
                parent
                items {
                  title
                  description
                  tags
                }
              }
            }
          }
        }
      }
    `}
    render={data => <SearchBar data={data} {...props} />}
  />
)
